/** §9 主号开通配套 — defaults; FC amount from uo_config. */
export const REGISTRATION_CONFIG_KEYS = {
  MAIN_SP2: 'registration.main_sp2',
  MAIN_TP: 'registration.main_tp',
  MAIN_FC: 'registration.main_fc',
  /** Sponsor RP debit when registering a new downline member. */
  SPONSOR_RP: 'registration.sponsor_rp',
  /** Sponsor TP debit when registering a new downline member. */
  SPONSOR_TP: 'registration.sponsor_tp',
  /** UO credited to the new member after sponsor registration. */
  MEMBER_UO_GRANT: 'registration.member_uo_grant',
  /** @deprecated sponsor paid UO — use SPONSOR_RP + SPONSOR_TP */
  SPONSOR_UO: 'registration.sponsor_uo',
  /** @deprecated sponsor paid FC — use SPONSOR_RP + SPONSOR_TP */
  SPONSOR_FC: 'registration.sponsor_fc',
  /** @deprecated use SPONSOR_RP — legacy EP key kept for config migration */
  SPONSOR_EP: 'registration.sponsor_ep',
  /** When `true`, `POST /api/auth/register` best-effort calls activate-main if balances suffice. */
  AUTO_ACTIVATE_MAIN: 'registration.auto_activate_main',
  TP_AUTO_AUDIT: 'recharge.tp_auto_audit',
} as const;

export const REGISTRATION_PACKAGE_DEFAULTS = {
  sp2: '950',
  tp: '50',
  fc: '1',
} as const;

/** Defaults for logged-in sponsor registration — 900 RP + 100 TP + 0.05 FC; new member receives UO grant. */
export const REGISTRATION_SPONSOR_DEFAULTS = {
  rp: '900',
  tp: '100',
  /** Flat FC fee on 注册进场, matching legacy 创建账号. */
  fc: '0.05',
  member_uo_grant: '950',
} as const;

/** Sponsor register-member package tiers (legacy 100$ / 1000$ / 10000$). */
export type SponsorRegisterPackage = 'E1' | 'E2' | 'E3';

export const SPONSOR_REGISTER_PACKAGE_DEFAULTS: Record<
  SponsorRegisterPackage,
  { rp: string; tp: string; queue_ap: string; queue_usd: string }
> = {
  E1: { rp: '90', tp: '10', queue_ap: '50', queue_usd: '100' },
  E2: { rp: '900', tp: '100', queue_ap: '500', queue_usd: '1000' },
  /** E3 gated by `registration.e3_enabled` — principal 10000$, 90% RP + 10% TP. */
  E3: { rp: '9000', tp: '1000', queue_ap: '5000', queue_usd: '10000' },
};

export const SPONSOR_REGISTER_CONFIG_KEYS = {
  E1_RP: 'registration.sponsor_rp_e1',
  E1_TP: 'registration.sponsor_tp_e1',
  E1_QUEUE_AP: 'registration.queue_ap_e1',
  E1_QUEUE_USD: 'registration.queue_usd_e1',
  E2_RP: 'registration.sponsor_rp_e2',
  E2_TP: 'registration.sponsor_tp_e2',
  E2_QUEUE_AP: 'registration.queue_ap_e2',
  E2_QUEUE_USD: 'registration.queue_usd_e2',
  E3_RP: 'registration.sponsor_rp_e3',
  E3_TP: 'registration.sponsor_tp_e3',
  E3_QUEUE_AP: 'registration.queue_ap_e3',
  E3_QUEUE_USD: 'registration.queue_usd_e3',
  /** When true, sponsors may register E3 (三星) packages. Default off. */
  E3_ENABLED: 'registration.e3_enabled',
} as const;
